module.exports = __webpack_public_path__ + "img/icons_27.268be0d1.svg";